import Vue from 'vue';
import template from '!!raw-loader!./dialog-form-panel-template.html';
import create from '../base';
import './dialog-form-panel.css';

const { render } = Vue.compile(template);

function createMixins ({ methods, computed, cancel, watch, dataProps = {} }) {
  const {
    size, formStyle = {}, butStyle = {}, labelWidth = '150px', labelPosition,
    isCancel = true, showBtn = true, reset = false,
    cancelButton = '取消', subButton = "保存" } = dataProps
  return {
    data () {
      return {
        size,
        formStyle,
        labelWidth,
        labelPosition,
        showBtn,
        cancelButton,
        subButton,
        isCancel,
        reset,
        butStyle
      };
    },
    methods: {
      onCancel () {
        if (cancel) cancel(this)
      },
      getProp (idx) {
        return `${idx}.value`;
      },
      ...methods
    },
    computed,
    watch,
    props: ['attributes'],
  }
}


export default function (props, dataProps) {
  const { watch, computed, methods, cancel, ...otherProps } = props;
  const mixins = [createMixins(
    {
      methods,
      computed,
      watch,
      cancel,
      dataProps,
    }
  )]
  return create({
    ...otherProps,
    render,
    mixins
  })
}
